<template>
    <div class="form-input">
        <label v-if="label !== ''">{{ label }} <span v-if="required" class="required">*</span></label>
        <div class="input">
            <input type="text" :placeholder="placeholder" :value="colorValue" @input="handleInput" :readonly="readonly" @change="changeInput">
            <InputColorPicker v-model="color" @input="handleColor"/>
            <btn v-if="reset" square style="min-width: 26px" @click="resetColor">
                <tooltip :text="$t('Reset color')" position="left">
                    <i class="fal fa-ban"></i>
                </tooltip>
            </btn>
        </div>
    </div>
</template>

<script>
import Btn from "@/modules/buttons/btn";
import InputColorPicker from 'vue-native-color-picker'
import Tooltip from "@/modules/tooltip";
export default {
    name: "input-color",
    components:{Tooltip, InputColorPicker,Btn},
    model:{
        prop:'value',
        event:'change',
    },
    props:{
        value:{type:String},
        label:String,
        placeholder:String,
        required:Boolean,
        readonly:Boolean,
        reset:Boolean,
    },
    data(){
        return{
            color:this.value,
        }
    },
    methods:{
        handleInput(e){
            this.$emit("input",e.target.value)
        },
        handleColor(){
            this.$emit("input",this.color)
        },
        changeInput(e){
            this.$emit("change",e.target.value)
        },
        changeColor(){
            this.$emit("change",this.color)
        },
        resetColor(){
            this.color = "#000000"
            this.$emit("change","")
        }
    },
    watch:{
        value(){
            this.color = this.value;
        },
        color(){
            clearTimeout(this._timeout);
            
            this._timeout = setTimeout(() => {
                if(this.value === "" && this.color === "") return;
                this.changeColor();
            },1000)
        }
    },
    computed:{
        colorValue(){
            if(this.color === ""){
                return this.$t("default")
            }
            return this.color;
        }
    }
}
</script>